<!-- The exported code uses Tailwind CSS. Install Tailwind CSS in your dev environment to ensure all styles work. -->
<template>
  <div>
    <!-- 主视觉横幅区域 -->
    <!-- 删除 h-screen class属性 改为 min-h-screen -->
    <div class="pt md:min-h-screen flex flex-col">
      <div class="flex-1 flex flex-col md:flex-row">
        <!-- bg-gray-50 改为 bg-gray -->
        <div
          class="w-full md:w-1/2 bg-black flex items-center order-2 md:order-1"
        >
          <div
            class="px-6 py-12 md:py-0 md:px-12 max-w-2xl mx-auto text-center md:text-left"
          >
            <h1 class="text-4xl md:text-6xl font-bold text-white mb-8">
              <!-- 探索无界，北境相伴 -->
              {{$t('company.slogan')}}
            </h1>
            <p class="text-xl text-white mb-10">
              <!-- 与志同道合的伙伴一起，探索中国最美的骑行路线，体验无与伦比的骑行乐趣。让每一次骑行都成为难忘的冒险。 -->
              {{$t('company.describe')}}
            </p>
            <!-- <button
              class="bg-blue-600 hover:bg-blue-700 text-white px-10 py-4 rounded-md text-lg font-medium transition-all duration-200 !rounded-button whitespace-nowrap"
            >
              立即加入
              {{$t('company.join')}}
            </button> -->
          </div>
        </div>
        <div
          class="w-full md:w-1/2 h-[400px] md:h-screen relative overflow-hidden order-1 md:order-2"
        >
          <img
            :src="heroImage"
            alt="骑行场景"
            class="w-full h-full object-cover object-center"
          />
        </div>
      </div>
    </div>
    <!-- 滚动展示区域 -->
    <!-- <div class="py-12 bg-white overflow-hidden relative">
      <div
        class="flex animate-scroll space-x-8"
        :style="{ animationDuration: `${scrollItems.length * 5}s` }"
      >
        <div
          v-for="(item, index) in [...scrollItems, ...scrollItems]"
          :key="index"
          class="flex-none w-72"
        >
          <div
            class="bg-gray-50 rounded-lg p-6 h-full flex flex-col justify-between"
          >
            <div>
              <div class="text-4xl mb-4" v-html="item.icon"></div>
              <h3 class="text-xl font-bold text-gray-800 mb-2">
                {{ item.title }}
              </h3>
              <p class="text-gray-600">{{ item.description }}</p>
            </div>
            <div class="mt-4 text-blue-600 font-medium">{{ item.stats }}</div>
          </div>
        </div>
      </div>
    </div> -->
    <!-- 商城展示模块01 -->
    <section class="py-20 bg-black">
      <div class="container mx-auto px-6 grid grid-cols-1 md:grid-cols-2 gap-2">
        <div v-for="(product, index) in featuredProductsData" :key="index" class="relative">
          <div class="md:h-[800px] overflow-hidden">
            <img
          v-lazy-load="product.image"
          class="w-full h-full object-cover object-top transition-transform duration-500 hover:scale-105"
          :alt="product.title"
          src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" 
        />
          </div>
          <div class="p-6">
            <h3 class="text-xl font-bold text-white mb-2">
              {{ product.title }}
            </h3>
            <!-- <a class="text-white mb-4 " :href="product.link">更多详情 &rarr;</a> -->
            <router-link :to="{ path: `/product/${product.id}`, query: { type: 'bikeormore' } }" class="inline-block">
              <button
                class="text-white mb-4 "
              >
                更多详情 &rarr;
              </button>
            </router-link>
          </div>
        </div>
      </div>
    </section>
    <!-- 核心服务板块 -->
    <!-- <section class="py-20 bg-white">
      <div class="container mx-auto px-6">
        <h2
          class="text-3xl md:text-4xl font-bold text-center text-gray-800 mb-16"
        >
          我们的专业服务
        </h2>
        <div class="grid grid-cols-1 md:grid-cols-3 gap-10">
          <div
            class="flex flex-col items-center text-center p-6 rounded-lg hover:shadow-lg transition-all duration-300"
          >
            <div
              class="w-20 h-20 bg-blue-100 rounded-full flex items-center justify-center mb-6"
            >
              <i class="fas fa-route text-3xl text-blue-800"></i>
            </div>
            <h3 class="text-xl font-bold text-gray-800 mb-3">专业路线规划</h3>
            <p class="text-gray-600">
              根据您的骑行水平和偏好，我们提供定制化的路线规划，确保每一次骑行都是难忘的体验。
            </p>
          </div>
          <div
            class="flex flex-col items-center text-center p-6 rounded-lg hover:shadow-lg transition-all duration-300"
          >
            <div
              class="w-20 h-20 bg-blue-100 rounded-full flex items-center justify-center mb-6"
            >
              <i class="fas fa-bicycle text-3xl text-blue-800"></i>
            </div>
            <h3 class="text-xl font-bold text-gray-800 mb-3">高端装备推荐</h3>
            <p class="text-gray-600">
              我们精选全球顶级骑行装备，为您提供专业的购买建议，让您的骑行更加安全舒适。
            </p>
          </div>
          <div
            class="flex flex-col items-center text-center p-6 rounded-lg hover:shadow-lg transition-all duration-300"
          >
            <div
              class="w-20 h-20 bg-blue-100 rounded-full flex items-center justify-center mb-6"
            >
              <i class="fas fa-graduation-cap text-3xl text-blue-800"></i>
            </div>
            <h3 class="text-xl font-bold text-gray-800 mb-3">骑行技术指导</h3>
            <p class="text-gray-600">
              无论您是初学者还是资深骑手，我们的专业教练团队都能帮助您提升骑行技巧，享受更好的骑行体验。
            </p>
          </div>
        </div>
      </div>
    </section> -->
    <!-- 商城展示模块02 -->
    <section class="py-20 bg-white">
      <div class="container mx-auto px-6 grid grid-cols-1 md:grid-cols-3 gap-20">
        <div v-for="(bag, index) in canvasBagsData" :key="index" class="relative">
          <div class="overflow-hidden">
            <img
          v-lazy-load="bag.image"
          class="w-full h-full object-cover object-top transition-transform duration-500 hover:scale-105"
          :alt="bag.title"
          src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" 
        />
          </div>
          <div class="p-6">
            <h3 class="text-xl font-bold text-black mb-2">
              {{ bag.title }}
            </h3>
            <!-- <a class="text-black mb-4 " href="#">更多详情 &rarr;</a> -->
            <router-link :to="{ path: `/product/${bag.id}`, query: { type: 'bikeormore' } }" class="inline-block">
              <button
                class="text-black mb-4"
              >
                更多详情 &rarr;
              </button>
            </router-link>
          </div>
        </div>
      </div>
    </section>
    <!-- 过度主图画面 -->
    <div class="pt md:min-h-screen flex flex-col">
      <div class="flex flex-col md:flex-row md:relative">
        <div
          class="w-full md:h-screen md:absolute overflow-hidden"
        >
          <img
            :src="require('@/assets/ncoreimg/home2.jpg')"
            alt="骑行场景"
            class="w-full h-full object-cover object-center"
          />
        </div>
        <div class="flex md:justify-center md:items-center md:h-screen z-10 w-full">
          <div
            class="px-6 py-12 md:py-12 md:px-24 max-w-2xl mx-auto text-center bg-black md:mt-48 w-full md:w-auto md:rounded-2xl shadow-xl"
          >
            <h1 class="text-4xl md:text-4xl font-bold text-white mb-8">
              <!-- 探索无界，北境相伴 -->
              {{$t('company.slogan')}}
            </h1>
            <!-- <button
              class="bg-white text-black px-10 py-4 rounded-full text-lg font-medium transition-all duration-200 !rounded-button whitespace-nowrap"
            >
              立即加入
              {{$t('company.join')}}
            </button> -->
          </div>
        </div>
        
      </div>
    </div>
    <!-- 装备推荐区域 -->
    <section id="equipment" class="py-6 bg-white">
      <div class="container mx-auto px-6">
        <!-- <h2
          class="text-3xl md:text-4xl font-bold text-center text-gray-800 mb-4"
        >
          精选骑行装备
        </h2>
        <p class="text-center text-gray-600 mb-16 max-w-3xl mx-auto">
          我们精选全球顶级骑行装备，为您提供最佳的骑行体验。
        </p> -->
        <div class="relative">
          <swiper
            :modules="swiperModules"
            :slides-per-view="1"
            :space-between="20"
            :pagination="{ clickable: true }"
            :autoplay="{ delay: 5000, disableOnInteraction: false }"
            :breakpoints="{
              '640': {
                slidesPerView: 2,
                spaceBetween: 20,
              },
              '1024': {
                slidesPerView: 3,
                spaceBetween: 30,
              },
            }"
          >
            <swiper-slide v-for="(equipment, index) in equipmentsData" :key="index">
              <div
                class="bg-white rounded-lg overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 h-full"
              >
                <div class="h-64 overflow-hidden">
                  <img
                    v-lazy-load="equipment.image"
                    :alt="equipment.name"
                    class="w-full h-full object-cover object-top transition-transform duration-500 hover:scale-105"
                    src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" 
                  />
                </div>
                <div class="p-6">
                  <h3 class="text-xl font-bold text-gray-800 mb-2">
                    {{ equipment.name }}
                  </h3>
                  <p class="text-gray-600 mb-4 line-clamp-2-min-h-2-line" :title="equipment.description">{{ equipment.description }}</p>
                  <div class="flex justify-between items-center">
                    <span class="text-xl font-bold text-blue-800">{{
                      equipment.price
                    }}</span>
                    <!-- <button
                      class="bg-blue-800 hover:bg-blue-700 text-white px-4 py-2 rounded text-sm font-medium transition-all duration-300 cursor-pointer !rounded-button whitespace-nowrap"
                    >
                      查看详情
                    </button> -->
                    <router-link :to="{ path: `/product/${equipment.id}`, query: { type: 'bikeormore' } }" class="inline-block">
                      <button
                        class="bg-blue-800 hover:bg-blue-700 text-white px-4 py-2 rounded text-sm font-medium transition-all duration-300 cursor-pointer !rounded-button whitespace-nowrap"
                      >
                        更多详情 &rarr;
                      </button>
                    </router-link>
                  </div>
                </div>
              </div>
            </swiper-slide>
          </swiper>
        </div>
      </div>
    </section>
    <!-- 精选路线展示 -->
    <!-- <section id="routes" class="py-20 bg-gray-50">
      <div class="container mx-auto px-6">
        <h2
          class="text-3xl md:text-4xl font-bold text-center text-gray-800 mb-4"
        >
          精选骑行路线
        </h2>
        <p class="text-center text-gray-600 mb-16 max-w-3xl mx-auto">
          探索中国最美的骑行路线，从城市周边的休闲骑行到壮丽的山地挑战，总有一条适合您的路线。
        </p>
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          <div
            v-for="(route, index) in routes"
            :key="index"
            class="bg-white rounded-lg overflow-hidden shadow-md hover:shadow-xl transition-all duration-300"
          >
            <div class="h-56 overflow-hidden">
              <img
                :src="route.image"
                :alt="route.name"
                class="w-full h-full object-cover object-top transition-transform duration-500 hover:scale-105"
              />
            </div>
            <div class="p-6">
              <h3 class="text-xl font-bold text-gray-800 mb-2">
                {{ route.name }}
              </h3>
              <div class="flex items-center mb-3">
                <span
                  class="bg-blue-100 text-blue-800 text-xs font-medium px-2.5 py-0.5 rounded-full mr-2"
                  >{{ route.difficulty }}</span
                >
                <span class="text-gray-600 text-sm"
                  ><i class="fas fa-road mr-1"></i> {{ route.distance }}</span
                >
              </div>
              <p class="text-gray-600 mb-4">{{ route.description }}</p>
              <button
                class="bg-blue-800 hover:bg-blue-700 text-white px-4 py-2 rounded text-sm font-medium transition-all duration-300 cursor-pointer !rounded-button whitespace-nowrap"
              >
                查看详情
              </button>
            </div>
          </div>
        </div>
      </div>
    </section> -->
    <!-- 商城展示模块03 -->
    <section class="py-6 bg-white">
      <div class="container mx-auto px-6 grid grid-cols-1 md:grid-cols-3">

        <div class="overflow-hidden md:col-span-2">
          <img
            :src="require('@/assets/nhomebody/long-left.png')"
            class="w-full h-full min-h-full object-cover transition-transform duration-500 hover:scale-105"
          />
        </div>
        <div class="p-6 bg-black md:col-span-1 flex flex-col justify-center">
          <h3 class="text-xl font-bold text-white mb-2">
            城市周末休闲骑行集结
          </h3>
          <p class="text-white mb-4 ">我们定期组织城市绿道短途休闲骑行活动，面向所有日常通勤、休闲骑行爱好者，全程路线平缓、里程适中。出行前会统一讲解骑行安全要点、沿途补给点位，
            <br>也会同步分享配件日常调试、胎压把控、简单故障自查的实用技巧，大家可结伴结伴出行，交流日常骑行的装备使用心得。</p>
        </div>
      </div>
    </section>
    <section class="py-6 bg-white">
      <div class="container mx-auto px-6 grid grid-cols-1 md:grid-cols-3">

        <div class="overflow-hidden md:col-span-2 order-1 md:order-2">
          <img
            :src="require('@/assets/nhomebody/long-right.png')"
            class="w-full h-full min-h-full object-cover transition-transform duration-500 hover:scale-105"
          />
        </div>
        <div class="p-6 bg-black md:col-span-1 order-2 md:order-1 flex flex-col justify-center">
          <h3 class="text-xl font-bold text-white mb-2">
            郊野路线骑行体验出行
          </h3>
          <p class="text-white mb-4 ">针对偏好户外越野、长途骑行的骑友，定期规划郊野成熟骑行路线组织集体出行。<br>活动全程会安排随行装备技术指引，讲解越野路况下护具、刹车、避震类配件的适配选择与出行前检查事项，大家可结伴探索户外骑行路线，互相交流长途装备搭配、路况应对的经验，全程无打卡评奖环节，主打结伴安全骑行、经验交流。</p>
        </div>
      </div>
    </section>
     <!-- 商城展示模块04 -->
    <section class="py-20 bg-black">
      <div class="container mx-auto px-6 grid grid-cols-1 md:grid-cols-2 gap-2">
        <div v-for="car in racingCarsData" :key="car.id" class="relative">
          <div class="md:h-86 overflow-hidden">
            <img
              v-lazy-load="car.image"
              class="w-full h-full object-cover object-top transition-transform duration-500 hover:scale-105"
              src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" 
            />
          </div>
          <div class="p-6">
            <h3 class="text-xl font-bold text-white mb-2">
              {{ car.title }}
            </h3>
            <!-- <a :href="car.link" class="text-white mb-4">更多详情 &rarr;</a> -->
            <router-link :to="{ path: `/product/${car.id}`, query: { type: 'bikeormore' } }" class="inline-block">
              <button
                class="text-white mb-4 "
              >
                更多详情 &rarr;
              </button>
            </router-link>
          </div>
        </div>
      </div>
    </section>
    <!-- 社区展示区 -->
    <section id="community" class="py-20 bg-gray-50">
      <div class="container mx-auto px-6">
        <h2
          class="text-3xl md:text-4xl font-bold text-center text-gray-800 mb-4"
        >
          我们的骑行社区
        </h2>
        <p class="text-center text-gray-600 mb-16 max-w-3xl mx-auto">
          加入北境骑团，与志同道合的伙伴一起探索骑行的无限可能。
        </p>
        <div class="grid grid-cols-2 md:grid-cols-4 gap-4 mb-16">
          <div
            v-for="(photo, index) in communityPhotosData"
            :key="index"
            class="overflow-hidden rounded-lg h-48 md:h-64"
          >
            <img
              v-lazy-load="photo"
              alt="社区照片"
              class="w-full h-full object-cover object-top transition-transform duration-500 hover:scale-105"
              src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" 
            />
          </div>
        </div>
        <div class="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div class="bg-white rounded-lg p-8 text-center shadow-md">
            <div class="text-4xl font-bold text-blue-800 mb-2">
              {{ communityStatsData.totalDistance }}
            </div>
            <p class="text-gray-600">累计骑行里程</p>
          </div>
          <div class="bg-white rounded-lg p-8 text-center shadow-md">
            <div class="text-4xl font-bold text-blue-800 mb-2">
              {{ communityStatsData.activeMembers }}
            </div>
            <p class="text-gray-600">活跃会员数</p>
          </div>
          <div class="bg-white rounded-lg p-8 text-center shadow-md">
            <div class="text-4xl font-bold text-blue-800 mb-2">
              {{ communityStatsData.completedRoutes }}
            </div>
            <p class="text-gray-600">完成路线数</p>
          </div>
        </div>
      </div>
    </section>
    
  </div>
</template>

<script lang="ts" setup>
import { ref, onMounted } from "vue";
import { getCodeImg } from "@/api/realhome";

// 从API导入模拟数据
import { featuredProducts, canvasBags, equipments, communityPhotos, communityStats, racingCars } from '@/api/home'


import { Swiper, SwiperSlide } from "swiper/vue";
import SwiperCore, { Pagination, Autoplay } from "swiper";
// 注册模块（Swiper 9 必须）
SwiperCore.use([Pagination, Autoplay]);
// 引入样式
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/autoplay";
// swiper
const swiperModules = [Pagination, Autoplay];

// 主视觉横幅图片
const heroImage = require('@/assets/ncoreimg/homeImg.jpg');

// 定义响应式数据变量
const featuredProductsData = ref([]);
const canvasBagsData = ref([]);
const equipmentsData = ref([]);
const communityPhotosData = ref([]);
const communityStatsData = ref({});
const racingCarsData = ref([]);
const dataLoading = ref(true);

// 异步获取所有数据
const fetchAllData = async () => {
  try {
    // 并行请求所有数据
    const [featured, bags, equip, photos, stats, cars] = await Promise.all([
      featuredProducts(),
      canvasBags(),
      equipments(),
      communityPhotos(),
      communityStats(),
      racingCars()
    ]);
    
    // 更新响应式数据
    featuredProductsData.value = featured;
    canvasBagsData.value = bags;
    equipmentsData.value = equip;
    communityPhotosData.value = photos;
    communityStatsData.value = stats;
    racingCarsData.value = cars;
  } catch (error) {
    console.error('Failed to fetch home data:', error);
  } finally {
    dataLoading.value = false;
  }
};

// 组件挂载时获取数据
onMounted(() => {
  fetchAllData();
});

onMounted(() => {
  // 这段代码的主要功能是根据用户在页面上的滚动位置动态地为导航栏添加或移除阴影效果。具体来说，
  // 当页面的垂直滚动距离大于 100 像素时，导航栏会显示一个中等大小的阴影，使其在页面滚动时更加突出，
  // 提升用户体验。当滚动距离小于或等于 100 像素时，阴影效果会被移除，从而使页面顶部看起来更加简洁。
  // window.addEventListener("scroll", () => {
  //   const nav = document.querySelector("nav");
  //   if (window.scrollY > 100) {
  //     nav?.classList.add("shadow-md");
  //   } else {
  //     nav?.classList.remove("shadow-md");
  //   }
  // });
});


// 定义响应式变量 后期请求后端数据的测试方案
const loading = ref(false)
const queryParams = ref({}) // 根据实际需求初始化查询参数
const jobList = ref([])
const total = ref(0)

// 定义获取列表数据的方法
const getCode = async () => {
  loading.value = true
  try {
    const response = await getCodeImg()
    console.log(response)
  } finally {
    // 无论成功失败都关闭加载状态
    loading.value = false
  }
}
// getCode()
</script>

<style scoped>
.swiper {
  width: 100%;
  height: 100%;
  padding-bottom: 50px;
}
 /* 左向右滚动内容的动画效果 */
@keyframes scroll {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-100%);
  }
}
.animate-scroll {
  animation: scroll linear infinite;
}

.line-clamp-2-min-h-2-line {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  min-height: 3.5rem;
  line-height: 1.75rem;
}
</style>
